// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

//Backend access
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Grid } from "@mui/material";


function CameraSelects({ startTime, setStartTime, endTime, setEndTime }) {

    return (
        <SoftBox m={1}>
            <Grid container spacing={{ xxs: 1, sm: 3 }}>
                <Grid item xxs={12} sm={6}>
                    <SoftBox display="flex" flexDirection="row" justifyContent={{ xxs: "center", sm: "flex-end" }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker format="DD/MM/YYYY" value={startTime} maxDate={endTime.clone().subtract(1, 'hour')} onChange={(new_value) => { setStartTime(new_value) }} />
                        </LocalizationProvider>
                    </SoftBox>
                </Grid>
                <Grid item xxs={12} sm={6}>
                    <SoftBox display="flex" flexDirection="row" justifyContent={{ xxs: "center", sm: "flex-start" }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker format="DD/MM/YYYY" value={endTime} minDate={startTime.clone().add(1, 'hour')} onChange={(new_value) => { setEndTime(new_value) }} />
                        </LocalizationProvider>
                    </SoftBox>
                </Grid>
            </Grid>
        </SoftBox>
    );
}

// Typechecking props for the CameraSelects
CameraSelects.propTypes = {
    startTime: PropTypes.instanceOf(moment()),
    setStartTime: PropTypes.func,
    endTime: PropTypes.instanceOf(moment()),
    setEndTime: PropTypes.func
};

export default CameraSelects;

